import React from "react";

import styles from "./style.module.css";

export default function ProgressGroup({ progress }) {
  return (
    <div>
      <h3 className="form-title mb-2">Progresso</h3>
      <div className={styles.loadingContainer}>
        <div className={styles.loading} style={{ width: `${progress.width}%` }}>
          <div className={styles.bar}></div>
          <div className={styles.ico}>{progress.width === 100 ? "🎉" : "🎓"}</div>
        </div>
      </div>
      <p className="m-0 mt-3">
        Faltam <span>{progress.total_days < 0 ? 0 : parseInt(progress.total_days)} dias</span> para o grande dia!
      </p>
    </div>
  );
}
